import { NgForm } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { AttachDetachStepperModel as AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { Component, OnInit } from '@angular/core';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';
import { ConfigurationService } from '@sdbn/appclient';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';

@Component({
  selector: 'app-detach-truck',
  templateUrl: './detach-truck.component.html',
  styleUrls: ['./detach-truck.component.scss']
})
export class DetachTruckComponent implements OnInit {

  stepperModel: AttachDetachStepperModel;

  @ViewChild('detachTrailerForm', { static: true }) detachTrailerForm: NgForm;

  constructor(
    public translationService: TranslationService,
    private configurationService: ConfigurationService,
    private stepperService: TransportAttachDetachStepperService
  ) {

    this.stepperModel = this.stepperService.stepperModel;

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      if (!this.detachTrailerForm) {
        return false;
      }
      return this.detachTrailerForm.valid;
    };

    this.stepperModel.getNextStepIndex = () => {
      return 0;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      return true;
    };
  }

  ngOnInit() {
  }

  swapTrailerEnabled() {
    return this.configurationService.isEnabled(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }


}
